import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export interface ReleaseResultsConfirmModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

const tPrefix = "modals.releaseConfirmation";

export const ReleaseResultsConfirmModal: React.FC<
  ReleaseResultsConfirmModalProps
> = ({ onCancel, onConfirm }) => {
  const [t] = useTranslation();
  return (
    <Dialog
      open={true}
      onClose={onCancel}
      aria-labelledby="release-results-confirm-title"
    >
      <DialogTitle id="release-results-confirm-title">
        {t(`${tPrefix}.title`)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{t(`${tPrefix}.body`)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="light">
          {t(`${tPrefix}.cancel`)}
        </Button>
        <Button onClick={onConfirm} variant="contained" autoFocus>
          {t(`${tPrefix}.confirm`)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
